import BootScene from "./scenes/BootScene";
import TestScene from "./scenes/TestScene";
import ResultScene from "./scenes/ResultScene";

export default function gameConfig(parentEl) {
    return {
        type: Phaser.AUTO,
        parent: parentEl,
        backgroundColor: "#ffffff",
        width: 1000,   // wider
        height: 700,   // taller
        audio: { disableWebAudio: false },
        physics: { default: "arcade", arcade: { gravity: { y: 0 } } },
        scene: [BootScene, TestScene, ResultScene],
        // no Phaser DOM plugin needed (we use HTML overlay for Q1)
    };
}



